import type { ParentChildGroup } from '@repo/types/parent';
import type { UserPublic } from '@repo/types/users';

import type { ChildrenResourceResult } from './useChildrenResource';

import { ParentKey } from './keys';
import { ParentService } from './parentService';
import { useChildrenResource } from './useChildrenResource';

/**
 * Groups of every linked child, aggregated.
 */
export function useGetChildrenGroups(children: UserPublic[], enabled = true): ChildrenResourceResult<ParentChildGroup[]> {
  return useChildrenResource(
    children,
    (child) => [ParentKey.CHILD_GROUPS, child.id],
    (child) => ParentService.getChildGroups(child.id).then((response) => response.data),
    enabled
  );
}
